var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "eco_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#eco_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12.002C4 6.002 11 .5 21 2c-2.075 1.844-2.343 4.432-2.617 7.078-.32 3.094-.649 6.267-3.883 8.423-1.86 1.24-4.445 1.378-6.584.476a24.472 24.472 0 00-.376 5.021h-1.5a24.226 24.226 0 01.817-5.579C5.194 16.347 4 14.528 4 12.001zm4.218 4.544a24.07 24.07 0 015.573-10.5 23.808 23.808 0 00-6.516 9.992C5.938 15.135 5 13.602 5 11.425 5 6.071 11.5 1.5 19.5 2.5 18.235 3.975 18 5.97 17.755 8.054c-.337 2.859-.692 5.88-3.755 7.946-1.673 1.128-3.941 1.318-5.782.546z"
  }))));
}
export default SvgEco;